<div class="navigation-row-container" [ngClass]="{ 'at-end': isNavAtEnd }">
  <div class="navigation-row" (scroll)="onNavScroll($event)">
    <div class="nav-widget" [routerLink]="'/rewards/wallet'">
      <div class="w-100 d-flex justify-content-center">
        <div class="nav-icon gloss icon material-icons">qr_code</div>
      </div>
      <div class="font-size-14 text-center">
        {{ 'nav.wallet' | translate }}
      </div>
    </div>
    <div class="nav-widget" [routerLink]="'/rewards/marketplace'">
      <div class="w-100 d-flex justify-content-center">
        <div class="nav-icon gloss icon material-icons">redeem</div>
      </div>
      <div class="font-size-14 text-center">
        {{ 'nav.rewards' | translate }}
      </div>
    </div>

    <div class="nav-widget" [routerLink]="'/badges'">
      <div class="w-100 d-flex justify-content-center">
        <div class="nav-icon gloss icon material-icons">emoji_events</div>
      </div>
      <div class="font-size-14 text-center">
        {{ 'nav.challenges' | translate }}
      </div>
    </div>

    <div class="nav-widget" [routerLink]="'/games'">
      <div class="w-100 d-flex justify-content-center">
        <div class="nav-icon gloss icon material-icons material-symbols-outlined">stadia_controller</div>
      </div>
      <div class="font-size-14 text-center">
        {{ 'nav.games' | translate }}
      </div>
    </div>
    <div class="nav-widget" [routerLink]="'/earn'">
      <div class="w-100 d-flex justify-content-center">
        <div class="nav-icon gloss icon material-icons material-symbols-outlined">money</div>
      </div>
      <div class="font-size-14 text-center">
        {{ 'nav.earn' | translate }}
      </div>
    </div>
    <a class="nav-widget" href="{{ 'nav.more.info.link' | translate }}" target="_blank">
      <div class="w-100 d-flex justify-content-center">
        <div class="nav-icon gloss icon material-icons material-symbols-outlined">info</div>
      </div>
      <div class="font-size-14 text-center">
        {{ 'nav.more.info' | translate }}
      </div>
    </a>
  </div>
</div>
